import { type KioskDisplayVariant } from "~/stores/kiosk-session/hooks/use-kiosk-products/types";

import { parseVariantFormData } from "./parse-variant-form-data";
import { type ProductFormData } from "./route";

export function getVariantsTotalGrossPrice(
  variants: KioskDisplayVariant[],
  variantsData: ProductFormData["variants"]
) {
  if (!variantsData) return 0;
  const variantChoices = parseVariantFormData(variantsData);

  return variantChoices.reduce(
    (total, { id: choiceId, variantId, quantity }) => {
      const variant = variants.find((v) => v.id === variantId);
      if (!variant) return total;

      const choice = variant.choices.find((c) => c.id === choiceId)
        ?.unitDisplayPrice;
      if (!choice) return total;

      return total + choice * quantity;
    },
    0
  );
}
